module.exports = (__webpack_require__(1))(9);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/BuildContext.js from dll-reference rlink_core
// module id = 575
// module chunks = 0